import { RegisterUserRequest } from 'store/signup/signupAPI';

export interface SignupFormModel extends Omit<RegisterUserRequest, 'confirmPassword'> {
  password: string;
  parentEmail: string;
  relationshipToChild: string;
  tnc: boolean;
}

export const DEFAULT_FORM_VALUES: SignupFormModel = {
  firstName: '',
  lastName: '',
  hasFamilyName: true,
  dateOfBirth: '',
  email: '',
  confirmEmail: '',
  password: '',
  parentEmail: '',
  relationshipToChild: '',
  tnc: false,
};
